export const can = (user, action) => !!user?.permissions?.includes(action);

export const ROUTE_PERMS = {
  "/dashboard": "dashboard:view",
  "/leads": "leads:manage",
  "/quotes": "leads:manage",
  "/forms": "leads:manage",
  "/b2b": "b2b:manage",
  "/projects": "projects:view",
  "/inventory": "inventory:edit",
  "/online-orders": "orders:view",
  "/tickets": "tickets:manage",
  "/rma": "rma:manage",
  "/settings/workflows": "workflows:edit",
  "/settings/users": "users:manage",
  "/settings": "settings:manage",
};

export const homeFor = (user) => Object.keys(ROUTE_PERMS).find((p) => can(user, ROUTE_PERMS[p])) || "/login";

export const stageAction = (stage) => (stage.stageName.toLowerCase().includes("deliver") ? "projects:delivery" : "projects:workflow");
